/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Rental_Payout_Hold_UntilInputs */

const en_rental_payout_hold_until = /** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Payout releases: ${i?.date}`)
};

const es_rental_payout_hold_until = /** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El pago se libera: ${i?.date}`)
};

const fr_rental_payout_hold_until = /** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Déblocage du paiement : ${i?.date}`)
};

const de_rental_payout_hold_until = /** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auszahlung freigegeben: ${i?.date}`)
};

const id_rental_payout_hold_until = /** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pembayaran dilepas: ${i?.date}`)
};

/** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */
const ja_rental_payout_hold_until = en_rental_payout_hold_until;

/** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */
const zh_rental_payout_hold_until = en_rental_payout_hold_until;

/** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */
const ar_rental_payout_hold_until = en_rental_payout_hold_until;

/** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */
const it_rental_payout_hold_until = en_rental_payout_hold_until;

/** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */
const ru_rental_payout_hold_until = en_rental_payout_hold_until;

/** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */
const pt_rental_payout_hold_until = en_rental_payout_hold_until;

/** @type {(inputs: Rental_Payout_Hold_UntilInputs) => LocalizedString} */
const ko_rental_payout_hold_until = en_rental_payout_hold_until;

/**
* | output |
* | --- |
* | "Payout releases: {date}" |
*
* @param {Rental_Payout_Hold_UntilInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_payout_hold_until = /** @type {((inputs: Rental_Payout_Hold_UntilInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Payout_Hold_UntilInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_payout_hold_until(inputs)
	if (locale === "es") return es_rental_payout_hold_until(inputs)
	if (locale === "fr") return fr_rental_payout_hold_until(inputs)
	if (locale === "de") return de_rental_payout_hold_until(inputs)
	if (locale === "ja") return ja_rental_payout_hold_until(inputs)
	if (locale === "zh") return zh_rental_payout_hold_until(inputs)
	if (locale === "ar") return ar_rental_payout_hold_until(inputs)
	if (locale === "id") return id_rental_payout_hold_until(inputs)
	if (locale === "it") return it_rental_payout_hold_until(inputs)
	if (locale === "ru") return ru_rental_payout_hold_until(inputs)
	if (locale === "pt") return pt_rental_payout_hold_until(inputs)
	return ko_rental_payout_hold_until(inputs)
});